import Marty from "marty";

const NAV_CONSTANTS = Marty.createConstants([
    "NAV_TRANSITION_TO",
    "NAV_TOGGLE_MENU",
    "NAV_HIDE",
    "NAV_SHOW",
    "NAV_MODAL_SHOW",
    "NAV_MODAL_HIDE",
    "NAV_MODAL_FETCH"
]);

export default NAV_CONSTANTS;



/** WEBPACK FOOTER **
 ** ./app/constants/navConstants.js
 **/